import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
div :global(a) {
    text-decoration: none;
}
.breadcrumbs {
    padding-top: 24px;
    text-decoration: none;
    margin-bottom: calc(8px * 3);
}
.watchlist-breadcrumbs {
  max-width: 1230px;
  padding-left: 32px;
  padding-right: 32px;
  margin: 0 auto;
    margin-top: calc(8px * 3);
    background: #ffffff;
}
span {
    text-decoration: none;
    color: #898989;
    font-size: 12px;
}
a {
    text-decoration: none;
    color: #898989;
    font-size: 12px;
}
a:link {
    text-decoration: none;
    color: #898989;
    font-size: 12px;
}
a:hover {
    text-decoration: none;
    color: #898989;
    font-size: 12px;
}
a:active {
    text-decoration: none;
    color: #898989;
    font-size: 12px;
}
a:visited {
    text-decoration: none;
    color: #898989;
    font-size: 12px;
}
.nav-link {
    text-decoration: none;
    color: #898989;
    font-size: 12px;
}
.breadcrumbs .destination {
    color: #111111;
}
.compare-breadcrumbs .destination {
    color: #111111;
}
.watchlist-breadcrumbs .destination {
    color: #111111;
}
.select-funds-breadcrumbs .destination {
    color: #111111;
}
@media (max-width: 1080px) {
    .breadcrumbs {
        margin-bottom: 0;
        padding-top: calc(8px * 2);
    }
}
`;

export default styles;